// @flow

import React from 'react'
import classNames from 'classnames'
import ScrollAnimation from 'react-animate-on-scroll'
import { Parallax } from 'react-scroll-parallax'
import { useIntl } from 'gatsby-plugin-intl'
import { applyStylingHoc, type StyleOuterProps, type StyleProps } from '@fcse/tsbob/dist/lib/styling'
import { Container } from '../../../components/basic/Grid'
import messages from '../CaseStudy.lang'
import baseStyles from './CaseWelcome.scss'

type Props = {
  ...StyleProps,
  logo?: string,
  text: string,
  title?: string,
  img: string,
  logoMobile?: string
}

const CaseWelcome = ({ styles, logo, title, text, img, logoMobile }: Props) => {
  const { formatMessage } = useIntl()

  return (
    <Container className={styles.root} fluid>
      <div className={styles.imageWrap}>
        <ScrollAnimation animateIn="fadeInLeft" animateOnce>
          <Parallax y={[-4, 4]} className={styles.parallaxWrapper}>
            <div className={styles.imageContainer}>{img}</div>
          </Parallax>
        </ScrollAnimation>
      </div>
      <div className={styles.panel}>
        <div className={styles.titleWrap}>
          <span className={styles.title}>{formatMessage(title ? title : messages.welcomeTitle)}</span>
          {logoMobile && <span className={classNames(styles.titleImg, styles.titleImgMobile)}>{logoMobile}</span>}
          {logo && <span className={classNames(styles.titleImg, logoMobile && styles.withMobileImg)}>{logo}</span>}
        </div>
        <p className={styles.description}>{formatMessage(text)}</p>
      </div>
    </Container>
  )
}

export default applyStylingHoc(baseStyles)<$Diff<Props, StyleProps> & StyleOuterProps, Function>(CaseWelcome)
